module.exports = __webpack_public_path__ + "img/cn_pocket-20.39ddef4.jpg";